import {SET_MAX_TIME_VALIDATE, SET_MIN_TIME_VALIDATE, SET_VALIDATE} from "./actionTypes";

export function setMinTimeValidate(validate) {
  return {
    type: SET_MIN_TIME_VALIDATE,
    validate
  }
}

export function setMaxTimeValidate(validate) {
  return {
    type: SET_MAX_TIME_VALIDATE,
    validate
  }
}

export function setValidate(validate) {
  return {
    type: SET_VALIDATE,
    validate
  }
}